import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import CacheBuster from './CacheBuster';
import clsx from 'clsx';
import './styles.scss';
import styles from './App.module.scss';
import AccountHome from './views/accountHome/AccountHome';
import Index from './views/Index';
import Trial from './views/trial/Trial';

const hostCls = clsx(styles.host);

export default function App() {
    return (
        <div className={hostCls}>
            <>
                <CacheBuster>
                    {({ loading, isLatestVersion, refreshCacheAndReload }) => {
                        if (loading) return null;
                        if (!loading && !isLatestVersion) {
                            // You can decide how and when you want to force reload
                            refreshCacheAndReload();
                        }
                        return null;
                    }}
                </CacheBuster>
                <Router>
                    <RouteContainer />
                </Router>
            </>
        </div>
    );
}

const RouteContainer = () => {
    const subdomain = window.location.host.split('.')[0];
    console.log(subdomain);
    // const location = useLocation();
    // console.log(location);
    // const history = useHistory();
    // console.log(history);
    return (
        <>
            {subdomain === 'trial-v2' ? (
                <Trial />
            ) : (
                <div className={styles['view-container']}>
                    {/* if a route's host element is a div it will get display flex to fill the given space */}
                    <Switch>
                        <Route path="/families/:familyId/customers">
                            <AccountHome />
                        </Route>
                        <Route exact path="/">
                            <Index />
                        </Route>
                    </Switch>
                </div>
            )}
        </>
    );
};
